const standardizeHeights = (gridItemSelector, childSelectors) => {
  let offsetTop = 0;
  let columns = 0;

  const gridItems = document.querySelectorAll(gridItemSelector);

  gridItems.forEach((gridItem, i) => {
    if (i === 0) {
      offsetTop = gridItem.getBoundingClientRect().top + window.scrollY;
    }

    if (offsetTop !== gridItem.getBoundingClientRect().top + window.scrollY) {
      columns = i;
      return false;
    }

    return true;
  });

  if (columns === 0) {
    // All items fit on a single row...don't need columns
    columns = gridItems.length;
  }

  gridItems.forEach((gridItem, i) => {
    const remainder = i % columns;
    const numberOfSiblings = columns - 1;

    if (remainder === 0) {
      // This is the last grid item on the row
      // Grab all siblings to the right, then slice the correct number of siblings to be left for this row
      const rowSiblings = Array.from(gridItem.parentNode.children).slice(i, i + numberOfSiblings + 1);

      childSelectors.forEach((selector) => {
        let tallest = 0;

        // Remove any hard-coded heights before comparing
        rowSiblings.forEach((sibling) => {
          const child = sibling.querySelector(selector);
          if (child) {
            child.style.height = '';
          }
        });

        // Compare the heights of all siblings and record the tallest
        rowSiblings.forEach((sibling) => {
          const child = sibling.querySelector(selector);
          if (child) {
            const height = child.offsetHeight;
            if (height > tallest) {
              tallest = height;
            }
          }
        });

        rowSiblings.forEach((sibling) => {
          const child = sibling.querySelector(selector);
          if (child) {
            child.style.height = `${tallest}px`;
          }
        });
      });
    }
  });
};

export { standardizeHeights };
